import OLWebGLVectorLayerTile from 'ol/layer/WebGLVectorTile.js';
import WebGLVectorTileLayerRenderer from '../renderer/webgl/VectorTileLayer.js';

class WebGLVectorLayerTile extends OLWebGLVectorLayerTile {
    constructor(options = {}) {
        const baseOptions = Object.assign({}, options);
        super(baseOptions);
    }

    createRenderer() {
        return new WebGLVectorTileLayerRenderer(this, {
            style: this.style_,
            variables: this.styleVariables_,
            disableHitDetection: this.hitDetectionDisabled_,
            cacheSize: this.getCacheSize()
        });
    }
}

export default WebGLVectorLayerTile;
